<template>
    <div style="margin-bottom: 60px">
    <div class="input-data-wrap container-fluid">

        <div class="row input-data-header pl-3">
            <a class="col-12 font-weight-bold" data-toggle="collapse" href="#inputDataToggle" role="button" aria-expanded="true" aria-controls="inputDataToggle">
                入力情報
                <div class="openTri"><span class="rounded-down-arrow">▼</span>詳細を見る</div>
            </a>
        </div>
        <div class="row collapse p-3" id="inputDataToggle">
            <!--世帯主-->
            <div class="col-12 col-sm-6">
                <h6>世帯主</h6>
                <ul>
                    <li>
                        <label>年齢</label>
                        <span v-if="$store.state.setainushi.age">{{$store.state.setainushi.age}}歳</span>
                        <span v-else>-</span>
                    </li>
                    <li>
                        <label>職業</label>
                        <span v-if="$store.state.setainushi.shokugyou">{{this.shokugyouArr[$store.state.setainushi.shokugyou]}}</span>
                        <span v-else>-</span>
                    </li>
                    <li>
                        <label>手取り月収</label>
                        <span v-if="$store.state.setainushi.geshuu">{{$store.state.setainushi.geshuu}}万円</span>
                        <span v-else>-</span>
                    </li>
                    <li>
                        <label>手取りボーナス（年合計）</label>
                        <span v-if="$store.state.setainushi.bonus">{{$store.state.setainushi.bonus}}万円</span>
                        <span v-else>-</span>
                    </li>
                    <li>
                        <label>退職</label>
                        <span v-if="$store.state.setainushi.retirementAge">{{$store.state.setainushi.retirementAge}}歳</span>
                        <span v-else-if="$store.state.setainushi.retirementAge === 0">予定なし</span>
                        <span v-else>-</span>
                    </li>
                    <li>
                        <label>現在の貯蓄</label>
                        <span v-if="$store.state.setainushi.chochiku">{{$store.state.setainushi.chochiku}}万円</span>
                        <span v-else>-</span>
                    </li>
                </ul>
            </div>

            <!--配偶者-->
            <div class="col-12 col-sm-6">
                <h6>配偶者</h6>
                <ul>
                    <li v-if="!$store.state.haiguusha.ari">
                        <span>いない</span>
                    </li>
                    <li v-if="$store.state.haiguusha.ari">
                        <label>年齢</label>
                        <span v-if="$store.state.haiguusha.age">{{$store.state.haiguusha.age}}歳</span>
                        <span v-else>-</span>
                    </li>
                    <li v-if="$store.state.haiguusha.ari">
                        <label>職業</label>
                        <span v-if="$store.state.haiguusha.shokugyou">{{shokugyouArr[$store.state.haiguusha.shokugyou]}}</span>
                        <span v-else>-</span>
                    </li>
                    <li v-if="$store.state.haiguusha.ari">
                        <label>手取り月収</label>
                        <span v-if="$store.state.haiguusha.geshuu">{{$store.state.haiguusha.geshuu}}万円</span>
                        <span v-else>-</span>
                    </li>
                    <li v-if="$store.state.haiguusha.ari">
                        <label>手取りボーナス（年合計）</label>
                        <span v-if="$store.state.haiguusha.bonus">{{$store.state.haiguusha.bonus}}万円</span>
                        <span v-else>-</span>
                    </li>
                    <li v-if="$store.state.haiguusha.ari">
                        <label>退職</label>
                        <span v-if="$store.state.haiguusha.retirementAge">{{$store.state.haiguusha.retirementAge}}歳</span>
                        <span v-else-if="$store.state.haiguusha.retirementAge === 0">予定なし</span>
                        <span v-else>-</span>
                    </li>

                </ul>
            </div>

            <!--お子様-->
            <div class="col-12 col-sm-6">
                <h6>同一生計のお子さま</h6>
                <ul>
                    <li>
                        <label>お子さまの人数</label>
                        <span v-if="$store.state.okosama.ninzuu">{{$store.state.okosama.ninzuu}}人</span>
                        <span v-else>-</span>
                    </li>
                    <li v-for="(item, index)  in $store.state.okosama.ages" :key="index">
                        <label>第{{index+1}}子</label>
                        <span v-if="item.born == 1">{{item.age}}歳</span>
                        <span v-if="item.born == 2">{{item.age}}年後のご予定</span>
                        &nbsp;
                        <span v-if="item.school == 1">高校まで</span>
                        <span v-if="item.school == 2">大学まで</span>
                    </li>
                </ul>
            </div>

            <!--お住まい-->
            <div class="col-12 col-sm-6">
                <h6>お住まいのご計画</h6>
                <ul>
                    <li>
                        <label>ローン月額のご計画</label>
                        <span v-if="$store.state.osumai.loan">{{$store.state.osumai.loan}}万円/月</span>
                        <span v-else>-</span>
                    </li>
                    <li>
                        <label>ボーナス返済のご計画</label>
                        <span v-if="$store.state.osumai.bonus">{{$store.state.osumai.bonus}}万円/年</span>
                        <span v-else>-</span>
                    </li>
                    <li>
                        <label>金利</label>
                        <span v-if="$store.state.osumai.kinri">{{$store.state.osumai.kinri}}%</span>
                        <span v-else>-</span>
                    </li>
                    <li>
                        <label>返済期間</label>
                        <span v-if="$store.state.osumai.kikan">{{$store.state.osumai.kikan}}年</span>
                        <span v-else>-</span>
                    </li>
                    <li>
                        <label>自己資金</label>
                        <span v-if="$store.state.osumai.jikoshikin">{{$store.state.osumai.jikoshikin}}万円</span>
                        <span v-else>-</span>
                    </li>
                    <li>
                        <label>資金援助</label>
                        <span v-if="$store.state.osumai.shikinEnjo">{{$store.state.osumai.shikinEnjo}}万円</span>
                        <span v-else>-</span>
                    </li>
                </ul>
            </div>


        </div>

    </div>

        <!--ボタン-->
        <div class="row btn-re-input">
            <div class="col">
                <router-link to="/" class="btn btn-outline-primary btn-prev">もう一度入力する</router-link>
            </div>
        </div>


    <div class="input-data-wrap container-fluid">

        <div class="row input-data-header pl-3">
            <a class="col-12 font-weight-bold" data-toggle="collapse" href="#inputDataToggle2" role="button" aria-expanded="true" aria-controls="inputDataToggle">
                計算根拠
                <div class="openTri"><span class="rounded-down-arrow">▼</span>詳細を見る</div>
            </a>
        </div>
        <div class="row collapse" id="inputDataToggle2">
            <div class="col-12">

                <h6>収入の考え方</h6>
                <p>
                    ・「退職の年齢」までは「手取り月収」を収入とする<br>
                </p>
                <p>
                    ・収入は、年齢別に毎年一定の上昇率（〜39歳：1.8%、〜49歳：1.2%、50歳〜：1.5%）で増加<br>
                </p>
                <p v-if="taishokuKingaku!==null">
                ・会社員・公務員の場合「退職の年齢」の年に退職金（{{taishokuKingaku.toLocaleString()}}万円）を加算<br>（出典：厚生労働省 平成30年就労条件総合調査「結果の概況 退職給付（一時金・年金）の支給実態」）
                </p>
                <p>
                    ・65歳以降は、年金を加算
                </p>
                <p>
                    ・年金は、会社員・公務員：14.6万円/月、自営業・専業主婦/主夫：5.6万円<br>
                    （出典：厚生労働省年金局「令和元年度 厚生年金保険・国民年金事業の概況」）
                </p>

                <h6>支出の考え方</h6>
                <p>
                    ・住居費（ローン返済額）、教育費、光熱費、生活費の合計<br>
                </p>

                <h6>住居費</h6>
                <p>
                    ・ローン月額（{{ $store.state.osumai.loan }}万円/月）{{ loanBonusText }} を、{{ $store.state.osumai.kikan }}年間（最長80歳まで）計上<br>
                </p>

                <h6>教育費</h6>
                <p>
                    ・以下の金額/年を計上<br>
                    保育園：22.3万円、幼稚園：22.3万円、小学校：32.1万円、中学校：48.8万円、高校：45.7万円、大学：157.3万円（初年度89.7万円加算）<br>
                    （出典：「平成30年度子供の学習費調査の結果について（文部科学省）」「子ども1人当たりにかける教育費用（高校入学から大学卒業まで）が減少（日本政策金融公庫）」、高校までは公立、大学は私立文系にて設定）<br>
                </p>

                <h6>光熱費</h6>
                <p>
                    ・世帯人数に応じて、以下の金額を計上<br>
                    1人：1.17万円/月、2人：1.96万円/月、3人：2.27万円/月、4人：2.37万円/月、以降 0.2万円/人・月を加算<br>
                    （出典：「家計調査 家計収支編 2019年 世帯人員・世帯主の年齢階級別（総務省統計局）」）
                </p>

                <h6>生活費</h6>
                <p>
                    ・１年目の収入累計額（{{ $store.getters.setaiNenshu }}万円）の40%（{{ Math.round($store.getters.setaiNenshu*0.4*10)/10 }}万円/年：{{ Math.round($store.getters.setaiNenshu*0.4/12*10)/10 }}万円/月）を、90歳まで計上
                </p>



            </div>






        </div>


    </div>
    </div>
</template>

<script>

import masterTaishokukin from '@/store/master.taishokukin';

export default {
    name: "InputData.vue",
    data() {
        return {
            shokugyouArr:{
                1:'会社員',
                2:'公務員',
                3:'自営業',
                4:'専業主婦/主夫',
            }
        }
    },
    computed: {
        taishokuKingaku() {
            // console.log('masterTaishokukin: ', masterTaishokukin);
            // console.log(this.$store.state.setainushi.retirementAge);
            if (this.$store.state.setainushi.shokugyou == 1 || this.$store.state.setainushi.shokugyou == 2) {
                if (masterTaishokukin[this.$store.state.setainushi.retirementAge]) {
                    return masterTaishokukin[this.$store.state.setainushi.retirementAge];
                }
            }
            return null;
        },
        loanBonusText() {
            if (this.$store.state.osumai.bonus) {
                return 'と、ボーナス年額合計 '+ this.$store.state.osumai.bonus + '万円';
            }
            return '';
        }
    }
}
</script>

<style scoped lang="scss">
.input-data-wrap{

    .input-data-header{
        background: linear-gradient(to bottom, rgb(0 45 89 / 19%), #FFF) !important;

        padding-top: 8px;

        a{
            font-size: 18px;
            text-decoration: none;
            color: #000000;
        }
    }

    #inputDataToggle{
        border: solid 1px #bbb;
        border-top: none;

        ul {
            list-style: none;
            padding-left: 0;

        }

        label {
            margin-right: 8px;
        }


    }

    h6 {
        font-weight: bold;
    }

    #inputDataToggle2 {
        border: solid 1px #bbb;
        border-top: none;

        font-size: 0.9rem;

        h6 {
            margin-top: 1rem;
        }

        p {
            padding-left: 0.9rem;
            text-indent: -0.9rem;
            margin-bottom: 0.4rem;
            line-height: 1.2rem;
        }
    }

}

.btn-re-input {
    margin-top: 16px;
    margin-bottom: 16px;

    text-align: center;

    .btn-prev {
        background-color: #0c436f;
        color: #fff;
        font-weight: bold;
        line-height: 36px;

        padding: 0;

        width: 200px;
        height: 36px;

        border-radius: 18px;
    }

}

</style>